define([
    'jquery',
    './globals',
    './helpers/console',
], function ($, globals, console) {
    'use strict';

    var init = function () {
        $('.shopping_cart_mini').on('click', function(event) {
            event.preventDefault();

            var $this = $(this);
            var $link = $this.find('a');

            if ($link.attr('href')) {
                window.location = $link.attr('href');
            }
        });
    };

    return {
        init: init
    };
});
